var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 12C2.92969 9.34784 3.98326 6.8043 5.85862 4.92893C7.73398 3.05357 10.2775 2 12.9297 2C14.2429 2 15.5433 2.25866 16.7565 2.7612C17.9698 3.26375 19.0722 4.00035 20.0008 4.92893C20.9293 5.85752 21.6659 6.95991 22.1685 8.17317C22.671 9.38642 22.9297 10.6868 22.9297 12C22.9297 14.6522 21.8761 17.1957 20.0008 19.0711C18.1254 20.9464 15.5819 22 12.9297 22C11.6165 22 10.3161 21.7413 9.10285 21.2388C7.8896 20.7362 6.78721 19.9997 5.85862 19.0711C3.98326 17.1957 2.92969 14.6522 2.92969 12ZM18.9297 11H10.9297L14.4297 7.5L13.0097 6.08L7.08969 12L13.0097 17.92L14.4297 16.5L10.9297 13H18.9297V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.cc59e076b91a39b14ab5e86d107731b7.svg";
export { ForwardRef as ReactComponent };